import { useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';

export default function useSources() {
  const { sources } = useSelector((state: any) => state.entities);

  const sourcesRef = useRef(sources);
  sourcesRef.current = sources;

  const getSourceById = useCallback((id: number) => sourcesRef.current[id], []);

  return {
    getSourceById,
    sources,
  };
}
